import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "fileName", "previewContainer"]

  connect() {
    this.setupDirectUploadListeners()
  }

  imageSelected() {
    const fileInput = this.fileInputTarget
    const fileName = this.fileNameTarget

    if (fileInput.files.length > 0) {
      // Update file name display
      fileName.textContent = fileInput.files[0].name

      // Display preview
      this.showPreview(fileInput.files[0])
    }
  }

  showPreview(file) {
    const reader = new FileReader()
    const hasPreviewContainer = this.hasPreviewContainerTarget

    reader.onload = (e) => {
      const preview = document.createElement('img')
      preview.src = e.target.result
      preview.style.borderRadius = '50%'

      // Create/update preview container
      if (!hasPreviewContainer) {
        // Create new preview container
        const previewContainer = document.createElement('div')
        previewContainer.className = 'avatar-preview has-text-centered mt-3'
        previewContainer.dataset.profileEditTarget = "previewContainer"

        const figure = document.createElement('figure')
        figure.className = 'image is-128x128 mx-auto'
        figure.appendChild(preview)

        const helpText = document.createElement('p')
        helpText.className = 'help has-text-centered mt-2'
        helpText.textContent = 'New avatar preview'

        previewContainer.appendChild(figure)
        previewContainer.appendChild(helpText)

        // Add after the file input field
        this.fileInputTarget.closest('.field').after(previewContainer)
      } else {
        // Update existing preview
        const existingImg = this.previewContainerTarget.querySelector('img')
        existingImg.src = e.target.result
      }
    }

    reader.readAsDataURL(file)
  }

  setupDirectUploadListeners() {
    const fileInput = this.fileInputTarget

    // Listen for direct upload events
    fileInput.addEventListener('direct-upload:initialize', (event) => {
      console.log('Direct upload initialized for avatar')
    })

    fileInput.addEventListener('direct-upload:start', (event) => {
      console.log('Direct upload started for avatar')
    })

    fileInput.addEventListener('direct-upload:progress', (event) => {
      console.log(`Direct upload progress: ${event.detail.progress}%`)
    })

    fileInput.addEventListener('direct-upload:error', (event) => {
      console.error('Direct upload failed:', event.detail.error)
      this.handleUploadError(event.detail.error)
    })

    fileInput.addEventListener('direct-upload:end', (event) => {
      console.log('Direct upload completed for avatar')
    })
  }

  handleUploadError(error) {
    console.error('Avatar upload error:', error)
    // You could show an error message to the user here
    alert('Failed to upload avatar image. Please try again.')
  }
}
